module.exports = function filterMentionOverlaps(mentions) {
		
	mentions = cloneMentions(mentions);

	// Finds the first overlap (if any) between 2 adjacent mentions and removes
	// the mention having the shorter anchor text.
	var collapseFirstOverlap = function(mentions) {

					var prev = mentions[0];

				for (var i = 1; i < mentions.length; i++) {
					var curr = mentions[i];
		
					if (isAnchorOverlap(prev.anchor, curr.anchor)) {
						if (prev.anchor.text.length > curr.anchor.text.length) {
							return mentions.splice(i, 1);
						} else {
							return mentions.splice(i-1, 1);
						}
					};
					var prev = curr;
				}

				return false;
			
		}
		

	var numOverlaps = 0;
	while (collapseFirstOverlap(mentions)) {
		numOverlaps++
	}

	if (numOverlaps > 0) {
		//console.log(">>>> " + numOverlaps + " overlaps detected and collapsed.");
	}

	return mentions;
}



/**
 * @returns a deep copy of the specified mentions[] array.
 */
var cloneMentions = function(mentions) {
	return mentions.map(function(m) {
		return cloneMention(m);
	});
}

/**
 * @returns a deep copy of the specified mention object.
 */
var cloneMention = function(mention) {
	var clone, entity, anchor; 
	
		if(mention){
			if( mention.anchor !== undefined ){
			
			anchor = mention.anchor;
	
			entity = mention.entities[0];
			clone = {
				anchor: {start: anchor.start, stop: anchor.stop, text: anchor.text},
				entities: mention.entities, 
				text: mention.text	
			}
			
		};
	
			if (mention.discoveredByHuman) {
				clone.discoveredByHuman = true;
			}

		}
		
	

	return clone;
}


/**
 * Returns true only if anchors a1 and a2 overlap.  Assumes both anchors are
 * at least 1 character long.
 */
var isAnchorOverlap = function(a1, a2) {
		
	if (a1.start < a2.start) {
		return a1.stop >= a2.start;
	} else {
		return a2.stop >= a1.start;
	}
}

